import React, { useState } from 'react';
import('./style.css');

const LazyImage = (imgProps) => {
  const {
    source,
    fallbackSource,
    onLoad = (() => { }),
    onError = (() => { }),
    ratio = 1,
    className="",
    noStretch = false,
    wrapperStyle = {},
    ...props
  } = imgProps;

  const [src, setSrc] = useState(source);
  const [loaded, setLoaded] = useState(false);
  const [errored, setErrored] = useState(false);

  const blankSource = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

  const loadHandler = () => {
    if (src !== blankSource) {
      setLoaded(true);
      onLoad();
    }
  };

  const errorHandler = () => {
    if (src === source && fallbackSource) {
      setSrc(fallbackSource);
    } else {
      setSrc(blankSource);
      setErrored(true);
      onError();
    }
  };

  // Really, we want to emulate the same behavior we have throughout the rest of the site
  // for lazyloading. In the interest of time, I'm going to skip some of that. We need to
  // come back to this.
  //
  // See: app/assets/lazyload/index.js
  //
  // Particularly, I did not take the time to implement the lazysizes.js polyfill for
  // browsers that don't support the HTML <img> loading attribute's "lazy" option. I'll
  // leave that to Akash.
  //
  return (
    <picture id="lazy-image-wrapper" style={{ paddingTop: `${100 * ratio}%`, ...wrapperStyle }}>
      <img
        src={src}
        loading="lazy"
        className={className  + (noStretch ? ' no-stretch': ' stretch')}
        onLoad={() => loadHandler()}
        onError={() => errorHandler()}
        {...props}
      />
    </picture>
  );
}

export default LazyImage;